import React from 'react';
import { Stack } from '@mui/material';
import { ResourceDetailHeader } from 'js/components/ResourceDetailHeader';
import { RESOURCE_TYPE_CREDENTIAL_GROUP } from 'js/constants/resourceTypes';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import useCredentialsGroupAdapter from 'new/state/credentialsGroup/adapter/useCredentialsGroupAdapter';

interface CredentialsGroupDetailHeaderProps {
  readOnly: boolean;
  adminAccess: boolean;
  hideActions: boolean;
  data: any;
  isManaged: any;
  connectionOrVendorType: any;
  showPipelineButton?: boolean;
  onCloseDrawer?(): void;
}
const Connection = ResourceDetailHeader.TopContent.Connection;

const CredentialsGroupDetailHeader = (props: CredentialsGroupDetailHeaderProps) => {
  const { readOnly, adminAccess, data } = props;
  const { updateCredentialsGroupInfo } = useCredentialsGroupAdapter();
  const updateInfo = (id: number, info = {}) => {
    updateCredentialsGroupInfo(id, info);
  };

  return (
    <ResourceDetailHeader
      readOnly={readOnly}
      adminAccess={adminAccess}
      data={data}
      onCloseDrawer={props.onCloseDrawer}
      updateInfo={updateInfo}
    >
      <ResourceDetailHeader.TopContent>
        <Stack direction="row" alignItems="center" gap="16px">
          <Connection resourceType={RESOURCE_TYPE_CREDENTIAL_GROUP} data={data} />
          <ChipWithCopy tooltipTitle="Copy Credential Group ID" toCopy={data.id}>
            ID {data.id}
          </ChipWithCopy>
        </Stack>
      </ResourceDetailHeader.TopContent>
    </ResourceDetailHeader>
  );
};

export default CredentialsGroupDetailHeader;
